import {Injectable} from '@angular/core';

@Injectable()
export class StringUtilities {
  /**
   * Camel case a string given.
   * @param str The string to camel case.
   * @return the camel cased version of the given string.
   */
  public static camelize(str): string {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }

  public titleCase(str): string {
    return str.toLowerCase().split(' ').map(word => {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/StringUtilities.ts